export const sectionData = [
    {
        id: 1,
        title: 'Цифровое ТВ через приставку',
        text: 'Пользуйтесь расширенными возможностями цифрового ТВ. Покупайте фильмы, не отходя от телевизора. Смотрите запись передач за последние три дня.',
        hrefText: 'Выбрать тариф',
        href: '/bundles',
        src: 'tv-pack.png',
        label: 'Домашний телевизор',
    },
    {
        id: 2,
        title: 'ТВ со смартфона и планшета',
        text: 'Если заскучали в дороге, включите ребенку мультик с планшета, а себе — «Шерлока», и угадывайте преступника наперегонки с великим сыщиком. Смотрите любимые фильмы и передачи с мобильных устройств на IOS и Android.',
        hrefText: 'Скачайте приложение',
        href: '/domru-tv/mobile',
        src: 'tv-mobile.png',
        label: 'Мобильное приложение',
    },
    {
        id: 3,
        title: 'ТВ на вашем компьютере',
        text: 'Тёща захватила телевизор? Дети требуют мультики? Не ссорьтесь с домашними и досмотрите свой футбольный матч на компьютере. Мы сделали для вас удобный интернет-портал: смотрите более 200 каналов в прямом эфире.',
        hrefText: 'Перейти на movix.ru',
        href: 'https://movix.ru',
        src: 'tv-desk.png',
        label: 'Веб-портал tv.domru.ru',
    },
];
